import { render, staticRenderFns } from "./IndicatorEvolution.vue?vue&type=template&id=4f9bda0b&scoped=true&"
import script from "./IndicatorEvolution.vue?vue&type=script&lang=js&"
export * from "./IndicatorEvolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9bda0b",
  null
  
)

export default component.exports